module.exports = function(app) {
	app.directive('eprEmployeeSynopsis', function() {
		return {
			restrict: 'A',
			replace: false,
			template: require('directives/employee/eprEmployeeSynopsis.html'),

			scope: {
				employee: '=eprEmployeeSynopsis'
			},
			link: function() {
			},
			controller: [
				'$scope', '$rootScope', '$state','employee',function ($scope, $rootScope, $state,employee){
					$scope.setUmi = function(umi){	
						$state.go('employee.find.review', {umi:umi});			
					}

				}
			]
		};
	});
};
